import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AgencyReadSchemaRequest from '@careerstart/wae-common/schema/agency/read.post.req.json';

import { validateSchema } from '../../../../components/Form/validations';
import {
  selectAgencyDetail,
  selectIsAgencyLoading,
} from '../../../../store/selectors/dashboardSelector';
import { getAgencyForAgencyDetail } from '../../dashboardReducer';

/**
 * Custom hook for fetching recruiter dashboard data
 * Uses agency API filtered by recruiter's agency ID
 * @param {string} recruiterAgencyId - The recruiter's agency ID
 */
const useRecruiterDataFetching = (recruiterAgencyId) => {
  const dispatch = useDispatch();
  const agencyDetail = useSelector(selectAgencyDetail);
  const isGetAgencyLoading = useSelector(selectIsAgencyLoading);

  useEffect(() => {
    if (!recruiterAgencyId) return;

    const payload = {
      filters: [
        {
          operation: 'equalsID',
          field: '_id',
          value: recruiterAgencyId,
        },
      ],
    };
    const schemaErrors = validateSchema(payload, AgencyReadSchemaRequest);

    // FIXME: We do not want to do runtime checks for API validation. This will break the app.
    // Instead, we need to write automated tests that gaurantee our code matches API schemas.
    if (Object.keys(schemaErrors).length === 0) {
      dispatch(getAgencyForAgencyDetail(payload));
    }
  }, [dispatch, recruiterAgencyId]);

  return {
    agencyDetail,
    isGetAgencyLoading,
  };
};

export default useRecruiterDataFetching;
